import { useTranslation } from "react-i18next";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useBrowserInfoAdapter } from "../../../hooks";
import useInfoFromBrowser from "../../../hooks/useInfoFromBrowser";

import { BoxWrapper, Container } from "../../../components";
import { CustomSuBAndDescription } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { Button } from "../../../components/ui/Button/Button";
// import { Heading } from "../../../components/ui/Heading/Heading";
import { BrowserInfoTable } from "./components/BrowserInfoTable/BrowserInfoTable";

import { Section } from "../../../components/common/Section/Section.styled";
import { ButtonWrapper } from "./BrowserInfo.styled";

const BrowserInfo = () => {
  const { t } = useTranslation();

  const { result } = useInfoFromBrowser();

  const {
    headerData,
    renderRowContent,
    renderDropdownContent,
    renderHeaderTitle,
  } = useBrowserInfoAdapter();

  const handleReaperScan = () => {
    window.location.reload();
  };

  return (
    <>
      <Section variant="start">
        <Container>
          {/*<Heading title="Information from your browser" />*/}
          <HeadUpperSeo />

          <BoxWrapper>
            <CustomSuBAndDescription sub={t("browserInfo.browserInfoTitle")} />
            <BrowserInfoTable />

            <ButtonWrapper>
              <Button
                currentClass="primaryBtn"
                fullWidth
                onClick={handleReaperScan}
              >
                {t("browserInfo.scanButton")}
              </Button>
            </ButtonWrapper>

            <CustomSuBAndDescription
              sub={t("browserInfo.fromBrowserInfoTitle")}
              desc={t("browserInfo.fromBrowserInfoDescription")}
            />

            <AccordionTable
              data={result}
              headerData={headerData}
              renderRowContent={renderRowContent}
              renderDropdownContent={renderDropdownContent}
              renderHeaderTitle={renderHeaderTitle}
              showStatus={true}
            />
          </BoxWrapper>
        </Container>
      </Section>

      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

BrowserInfo.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default BrowserInfo;
